<template>
  <b-form-group id="keyboard_navigation" horizontal label-cols="3" label-size="md" :label="$t('labels.kbnav') + ':'">
    <b-row>
      <b-col lg="5">
        <label for="Non-strict" class="customi_label">
          <input type="radio" id="Non-strict" name="selected" value="Non-strict" class="invisible customi_input" v-model="selected">
          <div class="customi_div radio">
            <svg class="customi_svg" version="1.1" id="Layer_1" viewBox="0 0 20 20">
              <circle class="svg_bg" cx="10" cy="10" r="9"/>
              <circle class="svg_top radio_check" cx="10" cy="10" r="6"/>
            </svg>
          </div>
          <span>{{ $t("labels.knavHover")}}</span>
        </label>
      </b-col>
      <b-col lg="5">
        <label for="Strict" class="customi_label">
          <input type="radio" id="Strict" name="selected" value="Strict" class="invisible customi_input" v-model="selected">
          <div class="customi_div radio">
            <svg class="customi_svg" version="1.1" id="Layer_1" viewBox="0 0 20 20">
              <circle class="svg_bg" cx="10" cy="10" r="9"/>
              <circle class="svg_top radio_check" cx="10" cy="10" r="6"/>
            </svg>
          </div>
          <span>{{ $t("labels.knavNormal")}}</span>
        </label>
      </b-col>
    </b-row>
  </b-form-group>
</template>

<script>
export default {
  name: 'keyboard_navigation',
  data () {
    return {
      selected: localStorage.getItem('kb_nav') ? localStorage.getItem('kb_nav') : 'Non-strict',
      checked: true
    };
  },
  watch: {
    selected (val) {
      localStorage.setItem('kb_nav', val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/Settings/kbNav.vue